<div class="text-gray-800 font-semibold text-title-xs leading-theme-lg--line-height p-4 font-title">
  Tus comunidades
</div>
<div class="overflow-y-scroll max-h-4/5">
  @for (community of communities; track $index) {
    <div class="px-4 pt-2 pb-2">
      <community-selector [community]="community"></community-selector>
    </div>
  }
</div>
